//React
//Components
import {
  AlphaNumericInput,
  Button,
  Card,
  Chart,
  DashboardScreen,
  Dropdown,
  EmailRegistrationModal,
  FlexBox,
  Input,
  NumberInput,
  Radio,
  RupeeAmount,
  Screen,
  TitleBlock,
  TranslatedString,
  Image,
} from "components";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ROUTE_PATH from "Routes/paths";
import {
  registerClientApi,
  setGeneralDetails,
  UpdateUserApi,
  useGeneralDetails,
  useGetUserDetailsApiDetails,
  useRegisterClientApiDetails,
} from "Slices";
//Utils
import { ChangeHistory, EventManager, EventNames, validateEmail } from "utils";
//Styles
import "./styles.scss";
//Assets
import ProfileIcon from "assets/icons/profile.svg";
import NotificationIcon from "assets/icons/notification.png";
import ApplicationBannerHand from "assets/Dashboard/banner1.png";
//Library
import cx from "classnames";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const Landing = () => {
  //Dispatch
  const dispatch = useDispatch();
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");

  //Slices
  const userDetails = useGetUserDetailsApiDetails();

  useEffect(() => {
    setTimeout(() => {
      setFullName(userDetails?.data?.name);
      setEmail(userDetails?.data?.email);
      setMobile(userDetails?.data?.mobile);
    }, 0);
  }, []);

  useEffect(() => {
    setButtonDisabled(
      userDetails?.data?.name === fullName &&
        userDetails?.data?.email == email &&
        userDetails?.data?.mobile === mobile
    );
  }, [fullName, email, mobile]);

  const updateUserDetails = () => {
    dispatch(
      UpdateUserApi({
        name: fullName,
        email,
        mobile,
        callback: checkIfApplicationUpdated,
      })
    );
  };

  const checkIfApplicationUpdated = (response) => {
    response.success && toast.success("User Details updated successfully");
  };

  //Render UI
  const TopSection = (
    <FlexBox
      justifyBetween
      alignCenter
      className="top-section animated fadeInUp w-50"
    >
      <div>
        <p className="fs-32 font-heavy">Profile</p>
      </div>
      {/* <Card className="pd-10 h-100">
        <FlexBox justifyCenter alignCenter>
          <Image src={NotificationIcon} className="w-100" />
        </FlexBox>
      </Card> */}
    </FlexBox>
  );

  const FormSection = (
    <FlexBox flexColumn className="form-section w-50">
      <div className="mr-t-40 w-100">
        <AlphaNumericInput
          hasLabel
          value={fullName}
          onChange={setFullName}
          className="br-9 fs-14"
          placeholder={"Full Name"}
        />
      </div>
      <div className="mr-t-40 w-100">
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={"Email Address"}
          className="br-9 fs-14"
          hasLabel
        />
      </div>
      <div className="mr-t-40 w-100">
        <NumberInput
          hasLabel
          value={mobile}
          onChange={setMobile}
          className="br-9 fs-14"
          placeholder={"Mobile Number"}
        />
      </div>
      <div className="mr-t-40 w-80">
        <Button
          text={"Save"}
          className="w-100"
          disabled={buttonDisabled}
          onClick={() => updateUserDetails()}
        />
      </div>
    </FlexBox>
  );
  //Return UI
  return (
    <DashboardScreen
      className="profile-screen"
      hasSideMenu
      hasHeader
      screenAnimationClass="no-animation"
    >
      {TopSection}
      {FormSection}
    </DashboardScreen>
  );
};

export default Landing;
